/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21.772 23.6938A2.25 2.25 0 0 1 20.6388 24H2.25C1.0074 24 0 22.9926 0 21.75c0-.3984.1058-.7896.3065-1.1337l2.137-4.0968.0007-11.0196c0-.5522.4477-.9999 1-.9999h8.4993c.5523 0 1 .4477 1 1v.25c0 .5523-.4477 1-1 1H4.8911v9.75h15.5524v.0345l2.1391 4.0823c.589 1.0103.3022 2.2901-.6285 2.9589l-.1821.1181ZM3.8466 18.7519h15.4516l.8786 2.9981H2.9778l.8688-2.9981ZM16.7063 2.8652a.7502.7502 0 0 1 .7379-.6152h3l.1348.012a.7502.7502 0 0 1 .6152.738v7.5l-.0121.1348a.7502.7502 0 0 1-.7379.6152h-3l-.1348-.0121a.7502.7502 0 0 1-.6152-.7379V3l.0121-.1348ZM23.4442 3c0-1.6568-1.3431-3-3-3h-3c-1.6568 0-3 1.3432-3 3v7.5c0 1.6569 1.3432 3 3 3h3c1.6569 0 3-1.3431 3-3V3Z"
    clipRule="evenodd"
  />,
  'MenuDevices'
);
